import classNames from 'classnames';
import boxIconSrc from '../assets/box.svg';
import * as styles from './giftCardSelector.module.scss';

type GiftCardSelectorProps = {
  selected: string;
  onCheck: (id: string, value: number) => void;
  giftCards: { id: string; value: number; label: string }[];
};

const GiftCardSelector = ({ onCheck, giftCards = [], selected = '' }: GiftCardSelectorProps) => (
  <>
    <p>
      Gift cards can be applied to both the box membership and member-only sales. Recipients can use
      any leftover gift card credit to treat themselves to something extra!
    </p>
    <div className={styles.container}>
      {giftCards.map(({ id, value, label }, idx) => (
        <div className={styles.itemContainer} key={id}>
          <button
            type="button"
            id={id}
            className={classNames(styles.item, { [styles.selected]: selected === id })}
            onClick={() => onCheck(id, value)}
          >
            {label}
          </button>
          {idx === 0 && <BoxesQuantity label="1 Box" />}
          {idx === 4 && <BoxesQuantity label="4 Boxes (1 year)" />}
        </div>
      ))}
    </div>
  </>
);

type BoxesQuantityProps = {
  label: string;
};

export const BoxesQuantity = ({ label }: BoxesQuantityProps) => (
  <div className={styles.boxesQuantityContainer}>
    <img src={boxIconSrc} alt="box icon" />
    <span>{label}</span>
  </div>
);

export default GiftCardSelector;
